import { putData } from '../plugins/ApiCalls'

export function updateTrackingEvent(data) {
  return putData(`form-tracking-events/${data.id}`, data)
}
